<template>
	<div id="app">
		<home></home>
	</div>
</template>

<script>
	import Home from './components/Home'

	export default {
		name: 'app',
		components: {
			Home
		}
	}
</script>

<style>
	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
	body{
		background-color: #F2F2F2;
	}
</style>



// WEBPACK FOOTER //
// App.vue?16bbeed0